
import { Icon, addCollection } from "@iconify/vue";
import logos from "@iconify/json/json/logos.json";

addCollection(logos);
export default {
  components: {
    // Add Icon to list of used components
    Icon,
  },
};
